<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Icon Size:</span>
    <div class="wf-w-1/2">
      <VueSlider
        ref="size-slider"
        v-model="iconSize"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="iconSizeClasses"
      />
    </div>
  </li>
</template>

<script>
  import _ from "lodash";
  import { IconSizeClasses } from '../classes/IconSizeClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      iconSizeClasses() {
        return Object.keys(IconSizeClasses)
      },
      iconSize: {
        get() {
          let currentIconSize = this.elementClasses(this.classes)[this.device].find(elementClass => this.iconSizeClasses.includes(elementClass.value))
          if (!currentIconSize) {
            currentIconSize = {property: 'IconSize', value: 'ICON_SIZE_LG', touched: false}
            this.addToArray(this.module, [currentIconSize], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentIconSize.value
        },
        set: _.debounce(function (value) {
          let currentIconSize = this.elementClasses(this.classes)[this.device].find(elementClass => this.iconSizeClasses.includes(elementClass.value))
          value = {property: 'IconSize', value: value, touched: currentIconSize.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>
